import type { FluxErrorEntityErrorCodes } from '../types.js';

export const NotificationErrorCodes = {
  NotificationNotFound: {
    code: 'notification/not-found',
    explanation: 'A notificação que você está tentando acessar não foi encontrada.',
    localizations: {},
    message: 'Notificação não encontrada.',
  },
} as const satisfies FluxErrorEntityErrorCodes<'notification'>;

export const NotificationPreferenceErrorCodes = {
  NotificationPreferenceInvalidBitfield: {
    code: 'notification-preference/invalid-bitfield',
    explanation:
      'O bitfield de preferência de notificação é inválido. As configurações de preferência devem ser representadas corretamente.',
    localizations: {},
    message: 'A configuração de notificações informada é inválida.',
  },
  NotificationPreferenceInvalidPreferencesForGlobal: {
    code: 'notification-preference/invalid-preferences-for-global',
    explanation:
      'As preferências de notificação globais fornecidas são inválidas. Algumas configurações de preferência são específicas para fluxos (pipes).',
    localizations: {},
    message: 'As preferências de notificação globais são inválidas.',
  },
  NotificationPreferenceInvalidPreferencesForPipes: {
    code: 'notification-preference/invalid-preferences-for-pipes',
    explanation:
      'As preferências de notificação para os fluxos (pipes) fornecidas são inválidas. Algumas configurações de preferência são específicas para notificações globais.',
    localizations: {},
    message: 'As preferências de notificação para os fluxos são inválidas',
  },
  NotificationPreferenceMaxStarredPipes: {
    code: 'notification-preference/max-starred-pipes',
    explanation:
      'Você atingiu o número máximo de fluxos (pipes) que podem ser marcados como favoritos.',
    localizations: {},
    message: 'Você atingiu o número máximo de fluxos favoritos.',
  },
  NotificationPreferenceNotFound: {
    code: 'notification-preference/not-found',
    explanation:
      'A configuração de preferência de notificação que você está tentando acessar não foi encontrada.',
    localizations: {},
    message: 'Configuração de notificações não encontrada.',
  },
} as const satisfies FluxErrorEntityErrorCodes<'notification-preference'>;
